import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { PhoneNumberInput } from '@src/design-system/phone-number-input';
import { Textfield } from '@shared/fields/text-field';
import { ErrorMessage, useFormikContext } from 'formik';
import type { TContactInfoValues } from './constants';

const EditContactInfo = () => {
  const { values, setFieldValue } = useFormikContext<TContactInfoValues>();

  return (
    <div>
      <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
        <p className='text-gray-600 font-medium text-sm mb-2'>
          Contact Information
        </p>
        <Textfield
          name='personal_email'
          type='email'
          placeholder='ex: ticlick@gmail.com'
          label='Personal Email 1'
          className='mb-3'
        />
        <div className='flex flex-col gap-1 mb-3'>
          <Label className='mb-2'>Personal Phone Number</Label>
          <PhoneNumberInput
            name='personal_phone_number'
            placeholder='ex: +20124356762'
            onChange={(value) => setFieldValue('personal_phone_number', value)}
            value={(values as TContactInfoValues)?.personal_phone_number || ''}
          />
          <ErrorMessage
            name='personal_phone_number'
            component={CustomErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default EditContactInfo;
